import { View, Text, TouchableOpacity, ImageBackground, SafeAreaView, Dimensions, Platform, ScrollView, Image, FlatList} from 'react-native'
import { useState, useEffect } from 'react';
import React from 'react'
import Transfers from '../screens/Transfers'
import Activities from '../screens/Activities'
import Hotels from '../screens/Hotels'
import Hoho from '../screens/Hoho'
import Internet from '../screens/Internet'
import MyStyles from '../StyleSheets';
import {Ionicons} from '@expo/vector-icons';

export default function Dashboard() {
  //const width = Dimensions.get('window').width;
  //const height = Dimensions.get('window').height;
  //let scale = 1


  const [width, setWidth] = useState(Dimensions.get('window').width)
  let actualWidth = useState(Dimensions.get('window').width)
  const [height, setHeight] = useState(Dimensions.get('window').height);
  let actualHeight = useState(Dimensions.get('window').height)
  const [margin, setMargin] = useState(0);
  const [rowResponsive, setRowResponsive] = useState('row');
  const [scale, setScale] = useState(1);
  const [divider, setDivider] = useState(1);
  const [heightScale, setHeightScale] = useState(1);

  let fullWidth = 800;
  let borderShade = 'lightgray';
  let catBoxWidthMobile = 119;
  let catBoxWidthDesktop = 193;
  let catBoxHeightMobile = 60;
  let catBoxHeightDesktop = 80;

  let fontSizeNormalMobile = 14;
  let fontSizeMediumMobile = 17;
  let fontSizeLargeMobile = 20;
  let fontSizeNormalDesktop = 17;
  let fontSizeMediumDesktop = 20;
  let fontSizeLargeDesktop = 25;

  let fontName = 'Helvetica';
  let fontColor = 'gray';

  /* #################   O F F I C I A L   H E X   C O L O R S #################### */
  let ORANGE = '#FF6600';
  let LIGHTBLUE  = '#00B4FF';
  let DARKBLUE = '#393BB2';
  let YELLOW = '#fff605';
const [dimensionFlag, setDimensionFlag] = useState(0);

  const [dimension, setDimension] = useState(
      {
          winwidth :window.innerWidth,
          winheight : window.innerHeight,
      }
  )

  const updateDimension = () => {
      setDimension(
          {
              winwidth :window.innerWidth,
              winheight : window.innerHeight,
          }
      )
      setWidth(dimension.winwidth);
      setHeight(dimension.winheight);
  }

  //console.log('Height : ' + height);
  //console.log('Width : ' + width);

  useEffect(() => {
      //console.log('resize')
      //window.addEventListener('resize', updateDimension)
      setDestination('BORACAY'); ClickedDestinations(0,0,1,0,0);
      setModuleView(0); ClickedCategories(1,0,0,0,0);
      if (dimension.winwidth <= 500){
          setRowResponsive('column');
          setWidth(dimension.winwidth);
          setHeight(dimension.winheight);
          setDivider(1);
          setHeightScale(.5)
      } else { 
          setMargin(0)
          setRowResponsive('row')
          setWidth(800)
          setHeight(dimension.winheight);
          setDivider(.45)
          setHeightScale(1)
      }
      return() => {
         // window.removeEventListener('resize', updateDimension)
      }
    }, [])

  const [destinationClicked, setDestinationClicked] = useState(0)
  const main_bg = require("../assets/main_bg.jpg");
  const destImage01 = require("../assets/destinations/boracay.png");
  const destImage02 = require("../assets/destinations/bohol.png");
  const destImage03 = require("../assets/destinations/bacolod.png");
  const destImage04 = require("../assets/destinations/cebu.png");
  const destImage05 = require("../assets/destinations/iloilo.png");
  const destImage06 = require("../assets/destinations/capiz.png");
  const destImage07 = require("../assets/destinations/antique.png");
  const destImage08 = require("../assets/destinations/kalibo.png");

  const catImage01 = require("../assets/categories/transfer.png");
  const catImage02 = require("../assets/categories/activities.png");
  const catImage03 = require("../assets/categories/hotels.png");
  const catImage04 = require("../assets/categories/hoho.png");
  const catImage05 = require("../assets/categories/internet.png");

  const [xpos, setXpos] = useState(0);
  const [x2pos, setX2pos] = useState(0);
  const [destination, setDestination] = useState('');
  const [moduleView, setModuleView] = useState(9); /* 0=Transfers 1=Activities 2=Hotels 3=HOHO 4=Internet */

  const [clickDest0, setClickDest0] = useState(0);
  const [clickDest1, setClickDest1] = useState(0);
  const [clickDest2, setClickDest2] = useState(0);
  const [clickDest3, setClickDest3] = useState(0);
  const [clickDest4, setClickDest4] = useState(0);

  const [clickCat0, setClickCat0] = useState(1);
  const [clickCat1, setClickCat1] = useState(1);
  const [clickCat2, setClickCat2] = useState(1);
  const [clickCat3, setClickCat3] = useState(1);
  const [clickCat4, setClickCat4] = useState(1);

  const [borderColor01, setBorderColor01] = useState('lightgray');
  const [borderColor02, setBorderColor02] = useState('lightgray');
  const [borderColor03, setBorderColor03] = useState('lightgray');
  const [borderColor04, setBorderColor04] = useState('lightgray');
  const [borderColor05, setBorderColor05] = useState('lightgray');

  const [catBorderColor01, setCatBorderColor01] = useState('lightgray');
  const [catBorderColor02, setCatBorderColor02] = useState('lightgray');
  const [catBorderColor03, setCatBorderColor03] = useState('lightgray');
  const [catBorderColor04, setCatBorderColor04] = useState('lightgray');
  const [catBorderColor05, setCatBorderColor05] = useState('lightgray');

  const ClickedDestinations = (a, b, c, d, e) => {
    let borderThicknessDest = 5
    a == 1 ? setClickDest0(borderThicknessDest) : setClickDest0(0)
    b == 1 ? setClickDest1(borderThicknessDest) : setClickDest1(0)
    c == 1 ? setClickDest2(borderThicknessDest) : setClickDest2(0)
    d == 1 ? setClickDest3(borderThicknessDest) : setClickDest3(0)
    e == 1 ? setClickDest4(borderThicknessDest) : setClickDest4(0)

    a == 1 || b == 1 || c == 1 || d == 1 || e == 1 ? setDestinationClicked(1) : setDestinationClicked(0)

    a == 1 ? setBorderColor01(ORANGE) : setBorderColor01('lightgray')
    b == 1 ? setBorderColor02(ORANGE) : setBorderColor02('lightgray')
    c == 1 ? setBorderColor03(ORANGE) : setBorderColor03('lightgray')
    d == 1 ? setBorderColor04(ORANGE) : setBorderColor04('lightgray')
    e == 1 ? setBorderColor05(ORANGE) : setBorderColor05('lightgray')
    
  }

  const ClickedCategories = (a, b, c, d, e) => {
    let borderThicknessCat = 5
    a == 1 ? setClickCat0(borderThicknessCat) : setClickCat0(1)
    b == 1 ? setClickCat1(borderThicknessCat) : setClickCat1(1)
    c == 1 ? setClickCat2(borderThicknessCat) : setClickCat2(1)
    d == 1 ? setClickCat3(borderThicknessCat) : setClickCat3(1)
    e == 1 ? setClickCat4(borderThicknessCat) : setClickCat4(1)

    a == 1 ? setCatBorderColor01(ORANGE) : setCatBorderColor01('lightgray')
    b == 1 ? setCatBorderColor02(ORANGE) : setCatBorderColor02('lightgray')
    c == 1 ? setCatBorderColor03(ORANGE) : setCatBorderColor03('lightgray')
    d == 1 ? setCatBorderColor04(ORANGE) : setCatBorderColor04('lightgray')
    e == 1 ? setCatBorderColor05(ORANGE) : setCatBorderColor05('lightgray')
  }

  function textColorBlue({children}) {
    return <View><Text style={{color: DARKBLUE}}>{children}</Text></View>;
  }
  return (
    <ImageBackground source={main_bg} resizeMode="cover" style={{flex: 1, alignItems: 'center', width: '100%', height: '110%'}}>
  <View style={{width: actualWidth, height: actualHeight + 200, backgroundColor:'blue'}}>
    <View style={{width:width + 18, height: height + 200, marginTop:0, borderWidth: width > 450 ? 6:0, padding:2, borderColor:'gray', fontFamily: fontName, backgroundColor:'white', justifyContent:'flex-start' }}>
      
        <View style={{alignItems:'flex-start', height:'30%', width:'100%', backgroundColor:'white', marginLeft:3}}>
          {/* *** TOP BAR *** */}
         
          <View style={{width:width * scale, height:30, justifyContent: 'flex-start', marginTop: 10, marginBottom: width > 450 ? 5:0 , alignItems:'flex-start'}}><Text style={{fontWeight:'700', marginLeft:5, fontSize: width > 450 ? fontSizeLargeDesktop: fontSizeLargeMobile, color:DARKBLUE}}>Step 1. Where do you want to go?</Text></View>
              {/* ##### BROWSWER BODY ##### */}
              <View style={{flexdirection: 'column', justifyContent:'flex-start', alignItems:'center', width:width, height:'100%', backgroundColor:'white'}}> 
                 
                      <View style={{width: width > 450 ? '98.7%':'98%', marginLeft: width > 450 ? -3: 7, backgroundColor:'white', flexDirection:'row', height: 150, fontSize: width > 450 ? fontSizeMediumDesktop: fontSizeMediumMobile  }}>
                        <ScrollView horizontal>
                            <View style={{width:width , height:140, flexDirection:'row', alignContent:'space-around', backgroundColor:'white', marginLeft: xpos - (width > 450 ? 100:350), marginTop:10 }}>
                              <View style={{width:205, height:'100%', borderRadius: 15, borderColor: borderColor01, borderWidth: clickDest0}}><TouchableOpacity onPress={() => {setDestination('BACOLOD'); ClickedDestinations(1,0,0,0,0); alert('Coming soon!')}} style={{width:196, height:'100%', alignSelf:'center', borderRadius: 12, backgroundColor:'lightgray'}}><Image source={destImage03} style={{width: 196, height: '100%',borderRadius:15}} /></TouchableOpacity></View>
                              <View style={{width:205, height:'100%', borderRadius: 15, borderColor: borderColor02, borderWidth: clickDest1}}><TouchableOpacity onPress={() => {setDestination('CEBU')   ; ClickedDestinations(0,1,0,0,0); alert('Coming soon!')}} style={{width:196, height:'100%', alignSelf:'center', borderRadius: 12, backgroundColor:'lightgray'}}><Image source={destImage04} style={{width: 196, height: '100%',borderRadius:15}} /></TouchableOpacity></View>
                              <View style={{width:205, height:'100%', borderRadius: 15, borderColor: borderColor03, borderWidth: clickDest2}}><TouchableOpacity onPress={() => {setDestination('BORACAY'); ClickedDestinations(0,0,1,0,0)}} style={{width:196, height:'100%', alignSelf:'center', borderRadius: 12, backgroundColor:'lightgray'}}><Image source={destImage01} style={{width: 196, height: '100%',borderRadius:15}} /></TouchableOpacity></View>
                              <View style={{width:205, height:'100%', borderRadius: 15, borderColor: borderColor04, borderWidth: clickDest3}}><TouchableOpacity onPress={() => {setDestination('IOILO')  ; ClickedDestinations(0,0,0,1,0); alert('Coming soon!')}} style={{width:196, height:'100%', alignSelf:'center', borderRadius: 12, backgroundColor:'lightgray'}}><Image source={destImage05} style={{width: 196, height: '100%',borderRadius:15}} /></TouchableOpacity></View>
                              <View style={{width:205, height:'100%', borderRadius: 15, borderColor: borderColor05, borderWidth: clickDest4}}><TouchableOpacity onPress={() => {setDestination('CAPIZ')  ; ClickedDestinations(0,0,0,0,1); alert('Coming soon!')}} style={{width:196, height:'100%', alignSelf:'center', borderRadius: 12, backgroundColor:'lightgray'}}><Image source={destImage06} style={{width: 196, height: '100%',borderRadius:15}} /></TouchableOpacity></View>
                            </View>
                        </ScrollView>
                        <View style={{width:0, height:140, justifyContent:'center', borderRadius:5}}><TouchableOpacity onPress={() => setXpos(xpos-50)} style={{width:35, height:35,  borderRadius:15, marginLeft: width * -1 + (width > 450 ? 13 : 8), backgroundColor:'blue', position:'absolute', opacity:.6}}><Ionicons style={{marginTop:0, marginLeft:3, marginTop:3}} name="caret-back-outline" color={'white'} size={25} /></TouchableOpacity></View>
                        
                        <View style={{width:0, height:140, justifyContent:'center', borderRadius:5}}><TouchableOpacity onPress={() => setXpos(xpos+50)} style={{width:35, height:35, justifyContent:'center', borderRadius:15, marginLeft: width > 450 ? -34:-34, backgroundColor:'blue', position:'absolute', opacity:.6}}><Ionicons style={{marginTop:0, marginLeft:3, marginTop:3}} name="caret-forward-outline" color={'white'} size={25} /></TouchableOpacity></View>
                      </View>

                      
                    <View style={{width:width * scale - 15 , height:30, marginLeft: width > 450 ? -5:0, marginTop:10, marginBottom: width > 450 ? 17:11, justifyContent: 'center', alignItems:'flex-start', backgroundColor:'white'}}><Text style={{fontWeight:'700', fontSize: width > 450 ? fontSizeLargeDesktop: fontSizeLargeMobile, color:DARKBLUE}}>Step 2. What do you want to book?</Text></View>
                        
                      <View style={{width: '100%', marginLeft:0, flexDirection:'row', height: width > 450 ? 112:70}}>
                        
                          <ScrollView horizontal>
                            <View style={{flexDirection:'row', width:'100%', height: width > 450 ? 130:70, justifyContent:'space-between', fontFamily: fontName, marginLeft: width > 450 ? 0: x2pos}}>
                              <View style={{width: width > 450 ? catBoxWidthDesktop: catBoxWidthMobile, height:width > 450 ? catBoxHeightDesktop: catBoxHeightMobile, borderRadius: 12, justifyContent:'center', marginLeft:5}}><TouchableOpacity onPress={() => {setModuleView(0); ClickedCategories(1,0,0,0,0)}}                        style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center', borderColor:catBorderColor01, borderWidth: clickCat0, backgroundColor:'white', borderRadius: 12}}><Text style={{fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile, color: fontColor, fontWeight:'700'}}>Transfers</Text></TouchableOpacity></View>
                              <View style={{width: width > 450 ? catBoxWidthDesktop: catBoxWidthMobile, height:width > 450 ? catBoxHeightDesktop: catBoxHeightMobile, borderRadius: 12,  justifyContent:'center',marginLeft:5}}><TouchableOpacity onPress={() => {setModuleView(1); ClickedCategories(0,1,0,0,0)}} style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center', borderColor:catBorderColor02, borderWidth: clickCat1, backgroundColor:'white', borderRadius: 12}}><Text style={{fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile, color: fontColor, fontWeight:'700'}}>Activities</Text></TouchableOpacity></View>
                              <View style={{width: width > 450 ? catBoxWidthDesktop: catBoxWidthMobile, height:width > 450 ? catBoxHeightDesktop: catBoxHeightMobile, borderRadius: 12,  justifyContent:'center',marginLeft:5}}><TouchableOpacity onPress={() => {setModuleView(2); ClickedCategories(0,0,1,0,0)}} style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center', borderColor:catBorderColor03, borderWidth: clickCat2, backgroundColor:'white', borderRadius: 12}}><Text style={{fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile, color: fontColor, fontWeight:'700'}}>Hop-on Hop-off</Text></TouchableOpacity></View>
                              <View style={{width: width > 450 ? catBoxWidthDesktop: catBoxWidthMobile, height:width > 450 ? catBoxHeightDesktop: catBoxHeightMobile, borderRadius: 12,  justifyContent:'center',marginLeft:5}}><TouchableOpacity onPress={() => {setModuleView(3); ClickedCategories(0,0,0,1,0)}} style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center', borderColor:catBorderColor04, borderWidth: clickCat3, backgroundColor:'white', borderRadius: 12}}><Text style={{fontSize: width > 450 ? fontSizeNormalDesktop: fontSizeNormalMobile, color: fontColor, fontWeight:'700'}}>Internet</Text></TouchableOpacity></View>
                              {/* <View style={{width: width > 450 ? catBoxWidthDesktop: catBoxWidthMobile, height:width > 450 ? catBoxHeightDesktop: catBoxHeightMobile, borderRadius: 12,  justifyContent:'center',marginLeft:4}}><TouchableOpacity onPress={() => {setModuleView(4); ClickedCategories(0,0,0,0,1); alert('Coming soon!')}} style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center', borderColor:catBorderColor05, borderWidth: clickCat4, backgroundColor:'white', borderRadius: 12}}><Text style={{fontSize: width > 450  ? fontSizeNormalDesktop: fontSizeNormalMobile, color: fontColor, fontWeight:'700'}}>Hotels</Text></TouchableOpacity></View>
                               */}
                            </View>
                          </ScrollView>
                          <View style={{width:0, height:70, justifyContent:'center', borderRadius:5}}><TouchableOpacity onPress={() => setX2pos(x2pos-50)} style={{width:30, height:30,  marginTop: width > 450 ? 5:-5, borderRadius:15,  marginLeft: width * -1 +3, backgroundColor:ORANGE, position:'absolute', opacity:.6}}><Ionicons style={{marginTop:0}} name="caret-back-outline" color={'white'} size={25} /></TouchableOpacity></View>
                          <View style={{width:0, height:70, justifyContent:'center', borderRadius:5}}><TouchableOpacity onPress={() => setX2pos(x2pos+50)} style={{width:30, height:30, marginTop:width > 450 ? 5:-5, borderRadius:15, marginLeft: width > 450 ? -40:-33, backgroundColor:ORANGE, position:'absolute', opacity:.4}}><Ionicons style={{marginTop:0}} name="caret-forward-outline" color={'white'} size={25} /></TouchableOpacity></View>
                      
                      
                      </View>

                      {/* *** MAIN PAGE *** */}
                     
                      <View style={{ width:(width * scale) , height:'70%', marginTop: width > 450 ? -27:-7, backgroundColor:'white'}}> 
                            <View style={{width: (width * scale) - 5, height:45, marginLeft:5,  justifyContent: 'center', alignItems:'flex-start', backgroundColor:'white'}}>
                              <Text style={{fontWeight:'700', fontSize: width > 450 ? fontSizeLargeDesktop: fontSizeLargeMobile, color:DARKBLUE}}>
                              {
                              moduleView === 0 ? 'Step 3. Book Your Transfers Here' : 
                              moduleView === 1 ? 'Steo 3. Book Your Activities Here' : 
                              moduleView === 2 ? 'Step 3. Get Your Hop-on Hop-off Cards Here' : 
                              moduleView === 3 ? 'Step 3. Get connected with Data and WiFi' : 
                              moduleView === 4 ? 'Step 3. Book Your Rooms Here' : ''
                              }</Text>
                            </View>
                            
                            <View style={{width:width * scale, height:'100%', backgroundColor:'white'}}><Text>
                            { destinationClicked == 0 ? '':''}
                            { 
                            moduleView === 0 && destinationClicked == 1 ? <Transfers dest={destination == 'BORACAY' ? '1':'0'} mainWidth={width} mainHeight={height *.7}/> : 
                            moduleView === 1 && destinationClicked == 1 ? <Activities/> : 
                            moduleView === 2 && destinationClicked == 1 ? <Hoho /> : 
                            moduleView === 3 && destinationClicked == 1 ? <Internet /> :
                            moduleView === 4 && destinationClicked == 1 ? <Hotels /> : ''
                            }</Text></View>

                      </View>

                </View>
        </View>
    </View>
    </View>
    </ImageBackground>
  )
}